// extracted by mini-css-extract-plugin
export default {"header":"ModalAlert_header__p5vYI","title":"ModalAlert_title__RLNaU","footer":"ModalAlert_footer__aYZVY"};